<template>
    <div class="extensions-dashboard-card">
        <redesign-base-card>
            <template #content>
                <extension-dashboard-card-header
                    :tag-content="[{iconName: '', text: extension?.allDataSummary?.TotalSum || '0:00:00'}]"
                    :user-name="extension.userName"
                    :name-styles="representativeNameStyling"
                />
                <div class="card-body">
                    <div class="calls-statistic">
                        <extension-dashboard-calls-statistic
                            :extension="extension"
                            :settings="settings"
                            :data="data"
                            @recently-logged-out-expired="emit('recently-logged-out-expired')"
                        />
                    </div>
                    <div class="pb-2 w-1/2">
                        <extension-dashboard-status-statistic
                            :data="data"
                            :extension="extension"
                        />
                    </div>
                </div>
            </template>
        </redesign-base-card>
    </div>
</template>

<script setup lang="ts">
import RedesignBaseCard from '@/components/RedesignBaseComponents/RedesignBaseCard.vue'
import { MergedExtension } from '@/types/extension'
import { Settings, WidgetExtended } from '@/types/dashboard'
import { computed } from 'vue'
import ExtensionDashboardCardHeader
    from '@/components/RedesignComponents/Cards/ExtensionsDashbordCards/ExtensionDashboardCardHeader.vue'
import ExtensionDashboardCallsStatistic
    from '@/components/RedesignComponents/Cards/ExtensionsDashbordCards/ExtensionDashboardCallsStatistic.vue'
import ExtensionDashboardStatusStatistic
    from '@/components/RedesignComponents/Cards/ExtensionsDashbordCards/ExtensionDashboardStatusStatistic.vue'

/* Props */
const props = withDefaults(
    defineProps<{
        data: WidgetExtended
        extension: MergedExtension,
        settings?: Settings
    }>(),
    {
        settings: () => ({}),
    }
)

/* Emits */
const emit = defineEmits<{
    (event: 'recently-logged-out-expired'): void
}>()

/*computed*/
const representativeNameStyling = computed(() => {
    return {
        fontSize: `${props.settings.agentNameFontSize}px`,
        lineHeight: `${props.settings.agentNameFontSize}px`
    }
})

</script>


<style scoped lang="scss">
.extensions-dashboard-card {
  .total-call {
    @apply text-xs font-medium text-gray-500;
    line-height: 27.94px;
    font-variant: all-small-caps;
  }
  .card-body {
    @apply flex items-stretch;
    background-color: var(--mainBgColor-color);
    .calls-statistic {
      @apply pb-2 w-1/2;
      border-right: 1px solid var(--colorWidgetBorder-color);
    }
  }
}

[dir="rtl"] {
    .extensions-dashboard-card {
        .card-body {
            .calls-statistic {
                border-right-width: 0;
                border-left: 1px solid var(--colorWidgetBorder-color);
            }
        }
    }
}

</style>
